import { connect } from 'react-redux';

import { capitalize } from 'utils/helpers/format';
import SelectProducts from '../../../create-new-common/SelectProducts';
import {
  getAllEnabled,
  getEnabledOptions,
  getInactiveListOptions,
  getStoreValueByProp,
  getViewBySelection,
  setBatchEnabledOptions,
  setEnabledOptions,
  setHasChangesToStepTwo,
  setSelectStepSearchTerm,
} from '../../store/createNewCarrierAuthSlice';

export const mapState = state => {
  const { authorizationBy } = getStoreValueByProp([])(state);
  const selection = getViewBySelection(state);
  // the shape of the selection object is not consistent between carrier and location, the following line addresses the discrepancy
  const name = authorizationBy === 'carrier' ? selection?.carrierName : selection?.nameShort;
  const identifier = authorizationBy === 'carrier' ? 'locations' : 'carriers';
  const toggleAllMessage = `Turn On All ${capitalize(identifier)}`;
  const headerMessage = `Which ${identifier} would you like to authorize for ${name}?`;

  return {
    allEnabled: getAllEnabled(state),
    authorizationBy,
    enabledOptions: getEnabledOptions(state),
    header: headerMessage,
    inactiveListOptions: getInactiveListOptions(state),
    quickFilterInput: getStoreValueByProp(['selectStepSearchTerm'])(state),
    toggleAllMessage,
  };
};

// put action functions here, will choose correct one in mergeProps
export const mapDispatchToProps = {
  setBatchEnabledOptions,
  setEnabledOptions,
  setHasChangesToStepTwo,
  setSelectStepSearchTerm,
};

export default connect(mapState, mapDispatchToProps)(SelectProducts);
